export default "__VITE_ASSET__1_6WV9fx__"